import { Text, Tooltip } from '@common/ui'
import { Anchor } from '@common/ui/mantine'
import { Link as RouterLink } from 'react-router-dom'
import { com } from '@eidu/web'
import useEntityById from '../../io/useEntityById'
import entityIdFromStringOrNull = com.eidu.entity.entityIdFromStringOrNull

type Props = {
  entityId: string
  showTooltip?: boolean
  variant?: 'default' | 'emphasized'
  historicalLabel?: string | null
}

const EntityLink = ({ entityId, showTooltip = true, variant = 'default', historicalLabel }: Props) => {
  const id = entityIdFromStringOrNull(entityId) ?? undefined
  const { entity, loading } = useEntityById(id)

  if (!id)
    return (
      <Text component="span" inherit ff="monospace">
        {entityId}
      </Text>
    )

  if (loading && !entity)
    return (
      <Text component="span" inherit c="dimmed">
        …
      </Text>
    )

  const liveLabel = entity?.primaryLabelText || undefined
  const showHistoricalSuffix = !!liveLabel && !!historicalLabel && liveLabel !== historicalLabel
  const resolvedLabel = liveLabel || historicalLabel || undefined
  const label = showHistoricalSuffix ? `${liveLabel} (Old label: ${historicalLabel})` : resolvedLabel ?? entityId
  const fallbackToId = !resolvedLabel

  const text = (
    <Text
      component="span"
      inherit
      ff={fallbackToId ? 'monospace' : undefined}
      fw={variant === 'emphasized' ? 500 : undefined}
    >
      {label}
    </Text>
  )

  const link = entity ? (
    <Anchor
      component={RouterLink}
      to={`/entities/${entity.entity.typeId.toString()}/view/${entity.entity.id.toString()}`}
      underline="hover"
      c="inherit"
      inherit
    >
      {text}
    </Anchor>
  ) : (
    text
  )

  return showTooltip ? (
    <Tooltip label={entityId} position="top">
      <span>{link}</span>
    </Tooltip>
  ) : (
    link
  )
}

export default EntityLink
